export default __webpack_public_path__ + "static/media/photo--lg--79.ed146630.jpg";